import React from 'react';
import { Grid, GridItem } from '@patternfly/react-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty } from 'lodash';
import { Box } from '@material-ui/core';

import useWindowDimensions from '../use_Window_Dimensions';
import { PrimaryButtonCircle, PrimaryButtonRoundBorder } from '../primary_button';
import useTranslateText from '../use_translate_text';
import _Checkbox from '../checkbox/checkbox';
import './card_information.scss';

export const CardInformation = (props) => {
  const { heading, headingContent, item, item2, img, traiangleImg, id, onDelete, onEdit, isDisabled, children, canShowCheckbox,
          onClickCheckBox, isChecked, MedCourtOrdered, isCategoryDisabled, Cvg_Amt } = props,
        itemCol = isEmpty(item2) ? 12 : 6,
        { translateText } = useTranslateText(),
        className = `card-information ${isDisabled && 'card-information--disabled'} `;

  return (
    <Grid className={className}>
      {isDisabled && <span className="card-information--disabled-span" />}
      <GridItem span={isEmpty(item2) ? 2 : 1}>
        {img && <img src={img} alt={translateText(heading)} />}
        {traiangleImg && <img src={traiangleImg} alt={translateText(headingContent)} />}
      </GridItem>
      <GridItem span={6}>
        <p className="f20-title">{translateText(heading)}</p>
        {MedCourtOrdered === 'yes' &&
          <Box className="mr-3" style={{ width: 270 }}>
            <h5 className="span_div_text_color" style={{ fontWeight: '500', fontSize: '10px' }}>
              {translateText(`Dependent is under a Court Order for benefit coverage.`)}
              {translateText(`Please contact your HR department to update/remove the dependent.`)}
            </h5>
          </Box>}
        <p className="f16-title ">{translateText(headingContent)}</p>
      </GridItem>
      <GridItem span={4} className={`${isCategoryDisabled && 'disabled-category'}`}>
        {onEdit &&
          <PrimaryButtonRoundBorder
            className="float-right"
            onClick={onEdit}
            label="Edit"
            icon="edit"
          />
        }
        {canShowCheckbox &&
          <_Checkbox {...{
            handleChange: onClickCheckBox,
            checked: isChecked,
            value: 'Select Plan',
            disableForm: isCategoryDisabled,
          }} />
        }
      </GridItem>
      {item &&
        <GridItem lg={itemCol || 12} className="card-information__item pt-4">
          {item.map((detail, index) => {
            const dispContent = detail?.title === 'Coverage :' ? translateText(detail?.content) :
              (detail?.title === 'Coverage Amt :' && Cvg_Amt &&
              props?.beneficiariesData?.length) ? typeof Cvg_Amt === 'string' ? Cvg_Amt?.trim() : Cvg_Amt : detail?.content;
            return (
              <Grid key={index} className="pb-2">
                <GridItem span={6}>
                  <p className="f14-title">{translateText(detail?.title) || ''}</p>
                </GridItem>
                <GridItem span={6}>
                  <p className="f14-content">{dispContent || ''}</p>
                </GridItem>
              </Grid>
            );
          })}
        </GridItem>
      }
      {item2 &&
        <GridItem lg={itemCol || 12} className="card-information__item2 pt-4">
          {item2.map((detail, index) => {
            return (
              <Grid key={index} className="pb-2">
                <GridItem span={5}>
                  <p className="f14-title">{detail?.title || ''}</p>
                </GridItem>
                <GridItem span={6}>
                  <p className="f14-content">{detail?.content || ''}</p>
                </GridItem>
              </Grid>
            );
          })}
        </GridItem>
      }
      {onDelete &&
        <GridItem span={12}>
          <PrimaryButtonCircle
            className="primary-button__circle float-right"
            onClick={() => onDelete({ id })}
            icon="trash-alt"
            size="2x"
          />
        </GridItem>
      }
      {children}
    </Grid>
  );
};

export const LongCardInformation = (props) => {
  const { items, onDelete, onEdit } = props,
        { translateText } = useTranslateText();

  return (
    <Grid>
      {items.map((card, i) => {
        const { heading, headingContent, item, item2, img, id } = card;

        // console.log('***item=', item);
        return (
          <GridItem key={i} lg={8} className="pr-3 pb-3">
            <Grid className="card-information">
              <GridItem span={1}>
                <img src={img} alt={translateText(heading)} />
              </GridItem>
              <GridItem span={7}>
                <p className="f20-title">{translateText(heading)}</p>
                <p className="f16-title ">{translateText(headingContent)}</p>
              </GridItem>
              <GridItem span={3}>
                {onEdit &&
                  <PrimaryButtonRoundBorder
                    className="float-right"
                    onClick={() => onEdit({ id })}
                    label="Edit"
                    icon="edit"
                  />
                }
              </GridItem>
              <GridItem lg={6}>
                {item.map((detail, index) => {
                  return (
                    <Grid key={index}>
                      <GridItem span={5}>
                        <p className="f14-title">{detail.title}</p>
                      </GridItem>
                      <GridItem span={6}>
                        <p className="f14-content">{detail.content}</p>
                      </GridItem>
                    </Grid>
                  );
                })}
              </GridItem>
              <GridItem lg={6} className="card-information__item2">
                {item2.map((detail, index) => {
                  return (
                    <Grid key={index}>
                      <GridItem span={5}>
                        <p className="f14-title">{detail.title}</p>
                      </GridItem>
                      <GridItem span={6}>
                        <p className="f14-content">{detail.content}</p>
                      </GridItem>
                    </Grid>
                  );
                })}
              </GridItem>
              {onDelete &&
                <GridItem span={12}>
                  <PrimaryButtonCircle
                    className="primary-button__circle float-right"
                    onClick={() => onDelete({ id })}
                    icon="trash-alt"
                    size="2x"
                  />
                </GridItem>
              }
            </Grid>
          </GridItem>
        );
      })}
    </Grid>
  );
};

export const SmallCardInformation = (props) => {
  const { heading, headingContent, icon, img, className, isActive, size, children, isSelected } = props,
        classNames = `card-information card-information__small ${className}`;
  const { width } = useWindowDimensions(),
        { translateText } = useTranslateText();
  // console.log('****props=', props)

  return (
    <div className="card-information__container">
      <Grid className={classNames}>
        {isActive &&
          <GridItem className="card-information__active-arrow">
            <FontAwesomeIcon
              icon="caret-right"
              size={size || '2px'}
            />
          </GridItem>
        }
        {width > 800 && <GridItem span={2} className="card-information__img">
          <img src={img} alt={heading} />
        </GridItem>}
        <GridItem span={7} className="card-information__header">
          <p className="f18-title">{translateText(heading)}</p>
          {width > 800 && <p className="f16-title">{translateText(headingContent)}</p>}
        </GridItem>
        <GridItem span={3} className="card-information__header-right">
          {isSelected &&
            <FontAwesomeIcon
              className="float-right card-information__check-circle"
              icon="check-circle"
              size="1.5x"
            />
          }
          {icon &&
            <PrimaryButtonRoundBorder
              className="float-right"
              label="Edit"
              icon="edit"
            />
          }
        </GridItem>
        {children}
      </Grid>
    </div>
  );
};

export default CardInformation;